import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";
import TreatmentKanbanViewBody from "components/ClinicalManagement/Treatments/TreatmentKanbanKitBody";

const TreatmentKanbanView = () => {
  useEffect(() => {
    document.title = "Treatments";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <TreatmentKanbanViewBody />
    </main>
  );
};

export default TreatmentKanbanView;
